import { makeStyles, Theme } from '@material-ui/core';
export const useStyles = makeStyles((theme: Theme) => ({
  margin: {
    marginBottom: theme.spacing(2),
  },
}));